import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import { Button, FormGroup, FormControl } from 'react-bootstrap';

import Actions, { thunks } from '@redux/app';
import { ProgressButton } from '@components';

const SETTINGS_TYPE = 'bio';

class CompanyBio extends Component {
	componentDidMount = () => {
		const { Organization } = this.props;
		this.handleOnChange(Organization.Biography);
	}

	UNSAFE_componentWillReceiveProps = ({ Organization }) => {
		const lastProps = this.props;
		if (!isEqual(lastProps.Organization, Organization)) this.handleOnChange(Organization.Biography);
	}

	shouldComponentUpdate = ({
		Organization,
		isEdit,
		biography,
		buttonState,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.Organization, Organization)
			|| !isEqual(lastProps.isEdit, isEdit)
			|| !isEqual(lastProps.biography, biography)
			|| !isEqual(lastProps.buttonState, buttonState)
		);
	}

	handleOnChange = (bio) => {
		const { setField } = this.props;
		setField(SETTINGS_TYPE, 'biography', bio);
	}

	onCancel = () => {
		const {
			Organization,
			setEditMode,
		} = this.props;
		this.handleOnChange(Organization.Biography);

		setEditMode(SETTINGS_TYPE, false);
	}

	onSave = (e) => {
		e.preventDefault();
		const { dispatch } = this.props;

		dispatch(thunks.updateClientDetails({ type : 'bio' }));
	}

	render() {
		const {
			biography,
			isEdit,
			buttonState,
			setEditMode,
			setRef,
		} = this.props;

		return (
			<div
				className="card-section"
				ref={(ref) => setRef(ref)}
			>
				<div className="flex">
					<h5 className="color-dark font-bold margin-bottom-20 flex-1">Company Bio</h5>
					<If condition={biography && !isEdit}>
						<Button
							bsStyle="link"
							onClick={() => setEditMode(SETTINGS_TYPE, true)}
						>
							<i className="fa fa-pencil margin-right-5" />
							{' '}
							Edit bio
						</Button>
					</If>
				</div>
				<Choose>
					<When condition={biography && !isEdit}>
						<p>{biography}</p>
					</When>
					<When condition={isEdit}>
						<FormGroup>
							<FormControl
								componentClass="textarea"
								placeholder="Enter bio"
								className="settings-form-field"
								name="biography"
								value={biography || ''}
								onChange={(e) => this.handleOnChange(e.target.value)}
							/>
						</FormGroup>
					</When>
					<Otherwise>
						<div className="flex-center flex-direction-column">
							<p>You have not added a bio</p>
							<Button
								bsStyle="primary"
								onClick={() => setEditMode(SETTINGS_TYPE, true)}
							>
								+ Add Bio
							</Button>
						</div>
					</Otherwise>
				</Choose>
				<If condition={isEdit}>
					<div className="width-all text-right margin-top-15">
						<Button
							bsStyle="link"
							className="margin-right-10"
							onClick={this.onCancel}
						>
							Cancel
						</Button>
						<ProgressButton
							type="submit"
							className="btn btn-primary height-42"
							text="Save"
							onClick={this.onSave}
							state={buttonState}
						/>
					</div>
				</If>
			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		user : { Organization = {} },
		[SETTINGS_TYPE] : {
			isEdit,
			biography,
			buttonState,
		},
	},
}) => ({
	Organization,
	isEdit,
	biography,
	buttonState,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	setField    : bindActionCreators(Actions, dispatch).setFormField,
	setEditMode : bindActionCreators(Actions, dispatch).setEditMode,
});

CompanyBio.propTypes = {
	Organization : PropTypes.object,
	biography    : PropTypes.string,
	buttonState  : PropTypes.string,
	dispatch     : PropTypes.func.isRequired,
	isEdit       : PropTypes.bool,
	setEditMode  : PropTypes.func.isRequired,
	setField     : PropTypes.func.isRequired,
	setRef       : PropTypes.func.isRequired,
};

CompanyBio.defaultProps = {
	Organization : {},
	biography    : '',
	buttonState  : '',
	isEdit       : false,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyBio);
